<template>
  <div class="login-wrap">
    <div class="logo">
      <img src="../../static/images/logo2.png">
    </div>
    <div class="title loginTitle">榆林智慧畜牧公共服务平台</div>
    <el-form label-position="left" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px"
      class="demo-ruleForm login-container">
      <div class="text">欢迎登录</div>
      <el-form-item prop="username" style="margin: 30px 0!important;">
        <el-input type="text" v-model="ruleForm.userAccount" auto-complete="off" placeholder="账号"></el-input>
      </el-form-item>
      <el-form-item prop="password" style="margin-bottom: 30px;">
        <el-input type="password" v-model="ruleForm.userPwd" auto-complete="off" placeholder="密码"></el-input>
      </el-form-item>
      <!-- <el-row>
        <el-col :span="12">
          <el-form-item prop="code">
            <el-input type="text" v-model="ruleForm.code" auto-complete="off" placeholder="图形验证码" @keyup.enter.native="submitForm('ruleForm')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" class="code-box">
          <img :src="ruleForm.codeimg" alt="" class="codeimg" @click="getcode()">
        </el-col>
      </el-row> -->
      <!-- <el-checkbox class="remember" v-model="rememberpwd">记住密码</el-checkbox> -->
      <el-form-item style="width:100%;">
        <el-button type="primary" style="width:100%;" @click="submitForm('ruleForm')" :loading="logining">登录</el-button>
      </el-form-item>
    </el-form>

  </div>
</template>
<script type="text/ecmascript-6">
import {

  login
} from '@/api/login'

export default {
  name: 'login',
  data () {
    return {
      // 定义loading默认为false
      logining: false,
      // 记住密码
      rememberpwd: false,
      ruleForm: {

        userAccount: '',
        userPwd: '',
        clientFlag: 'pc'

      },
      // rules前端验证
      rules: {
        userAccount: [{
          required: true,
          message: '请输入账号',
          trigger: 'blur'
        }],
        userPwd: [{
          required: true,
          message: '请输入密码',
          trigger: 'blur'
        }]
      },
      form: {
        userAccount: '',
        userPwd: ''
      }
    }
  },
  // 创建完毕状态(里面是操作)
  created () {

  },
  // 里面的函数只有调用才会执行
  methods: {

    // 获取info列表
    submitForm (formName) {
      var _this = this
      _this.$refs[formName].validate(valid => {
        if (valid) {
          _this.logining = true
          login(_this.ruleForm).then(response => {
            console.log(response)
            _this.logining = false
            localStorage.setItem('token', response.data.data.token)
            localStorage.setItem('userInfo', JSON.stringify(response.data.data))
            // _this.$store.commit('login', res.data)
            console.log(_this.$store)
            _this.$router.push({
              path: '/material/info'
            })
            // this.algoList = response.data.data.records
          }).catch((res) => {
            _this.logining = false
            _this.$message({
              type: 'error',
              message: '账号密码错误，请重新输入'
            })
          })

        // userBycount(param)
        // .then(res => {
        //   if (res.status == '200') {
        //     console.log(res.data)
        //         if(res.data!=null){
        //           if(res.data.roles.length>0){
        //             console.log(res.data.roles)
        //               var index = res.data.roles.indexOf(24)
        //               if(index>-1){
        //                     var params = {
        //                       mobile: _this.ruleForm.username,
        //                       passWord: _this.ruleForm.password,
        //                       userRole: 1
        //                     }
        //                     loginBtn(params)
        //                       .then(res => {
        //                         _this.loading = false
        //                         if (res.status == '200') {
        //                           // _this.$store.commit('login', 'true')
        //                           _this.$store.commit('login', res.data)
        //                           _this.$router.push({
        //                             path: '/index/index'
        //                           })
        //                         } else {
        //                           _this.$message({
        //                             type: 'info',
        //                             message: res.msg
        //                           })
        //                         }
        //                       })
        //                       .catch(err => {
        //                         _this.loading = false
        //                         _this.$message.error('加载失败，请稍后再试！')
        //                       })
        //               }else{
        //                  this.logining = false
        //                _this.$message({
        //                  type: 'warning',
        //                  message: '您暂无权限登录智慧畜牧公共服务平台，请联系管理员。'
        //                })
        //               }
        //           }else{
        //             this.logining = false
        //             _this.$message({
        //               type: 'warning',
        //               message: '您暂无权限登录智慧畜牧公共服务平台，请联系管理员。'
        //             })
        //           }
        //         }
        //   } else {
        //     _this.logining = false
        //     _this.$message({
        //       type: 'info',
        //       message: res.msg
        //     })
        //   }
        // })
        // .catch(err => {
        //   _this.loading = false
        //   // _this.$message.error('加载失败，请稍后再试！')
        // })
        } else {
          // 获取图形验证码
          // this.getcode()
          this.$message.error('请输入用户名密码！')
          this.logining = false
          return false
        }
      })
    }
  }
}
</script>
<style scoped>
  .login-wrap {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    height: 100vh;
    margin: 0;
    background: -webkit-linear-gradient(0deg, rgba(38, 153, 38, 1) 0%, rgba(119, 183, 55, 1) 100%);
    background: -webkit-linear-gradient(0deg, rgba(38, 153, 38, 1) 0%, rgba(119, 183, 55, 1) 100%);
    background: -webkit-linear-gradient(0deg, rgba(38, 153, 38, 1) 0%, rgba(119, 183, 55, 1) 100%);
    transition: All 0.15s ease-in-out;
    -webkit-transition: All 0.15s ease-in-out;
    -moz-transition: All 0.15s ease-in-out;
    -o-transition: All 0.15s ease-in-out;
    position: relative;

  }

  .logo {
    position: absolute;
    left: 60px;
    top: 60px
  }

  .logo img {
    width: 200px;
  }

  .title {
    font-weight: 700;
    font-size: 40px;
    color: #FFFFFF;
    text-align: center;
    line-height: 40px;
    padding-top: 60px;
  }

  .login-container {
    position: fixed;
    width: 300px;
    height: 300px;
    background: inherit;
    background: rgba(255, 255, 255, 1);
    border-radius: 10px;
    -moz-box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.247058823529412);
    -webkit-box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.247058823529412);
    box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.247058823529412);
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    padding: 30px;
  }

  .text {
    font-weight: 700;
    font-size: 20px;
    text-align: center;
    line-height: 20px;
    height: 35px;
  }

  .remember {
    margin: 0px 0px 35px 0px;
  }

  .code-box {
    text-align: right;
  }

  .codeimg {
    height: 40px;
  }
.el-input__inner {
    line-height: 50px !important;
    height: 50px !important;
    border: none !important;
    background: rgba(245, 247, 250, 1);
  }

.el-button--primary {
    padding: 0 !important;
    background: -webkit-linear-gradient(180deg, rgba(48, 191, 48, 1) 0%, rgba(149, 229, 69, 1) 100%);
    background: -moz-linear-gradient(270deg, rgba(48, 191, 48, 1) 0%, rgba(149, 229, 69, 1) 100%);
    background: linear-gradient(270deg, rgba(48, 191, 48, 1) 0%, rgba(149, 229, 69, 1) 100%);
    font-family: 'Arial Negreta', 'Arial Normal', 'Arial', sans-serif;
    font-weight: 700;
    font-style: normal;
    font-size: 20px;
    color: #FFFFFF;
    line-height: 50px;
    display: block;
    text-align: center;
    border: none;
  }
.el-form-item{
    width: 100%;
  }


</style>



// WEBPACK FOOTER //
// src/views/login.vue